import { render, staticRenderFns } from "./pure-form.vue?vue&type=template&id=3f801faf&scoped=true&"
import script from "./pure-form.vue?vue&type=script&lang=js&"
export * from "./pure-form.vue?vue&type=script&lang=js&"
import style0 from "./pure-form.vue?vue&type=style&index=0&id=3f801faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f801faf",
  null
  
)

export default component.exports